import * as Moment from 'moment'
import { extendMoment } from 'moment-range'
import PortalInstructorUnAvailability from '@classes/InstructorUnAvailability'
import { InstructorUnAvailability } from '@interfaces/InstructorUnAvailability'
import PortalInstructor from './Instructor'

const moment = extendMoment(Moment)

class PortalInstructorUnAvailabilities {
  unAvailabilities: InstructorUnAvailability[]
  Instructor: PortalInstructor

  constructor(unAvailabilities: InstructorUnAvailability[] = [], Instructor: PortalInstructor) {
    this.unAvailabilities = unAvailabilities
    this.Instructor = Instructor
  }

  get UnAvailabilities() {
    return (
      this.unAvailabilities?.map(
        unAvailability => new PortalInstructorUnAvailability(unAvailability, this.Instructor)
      ) || []
    )
  }

  filterByDateRange(start: Date, end: Date) {
    return this.UnAvailabilities.filter(({ CalendarStart, CalendarEnd }) => {
      const weekRange = moment.range(start, end)
      const schedRange = moment.range(CalendarStart, CalendarEnd)
      return weekRange.overlaps(schedRange)
    })
  }
}

export default PortalInstructorUnAvailabilities
